<template>
  <div>
    <!-- 
author: {uid: "4c71325e2b4f41f3", name: "SSmJaE"}
name: "SSmJaE"
uid: "4c71325e2b4f41f3"
bad: 0
good: 0
id: 21
title: "测试0.13016361559505185"
updateTime: "2020-12-24 19:55:38" 
-->
    <div class="report-title">{{ report.title }}</div>
    <div class="report-author">
      <a target="_blank" :href="`/user/detail/${report.author.name}`">
        {{ report.author.name }}
      </a>
    </div>
    <div
      class="report-content"
      :class="showFullContent ? 'show' : 'hide'"
      @click="showFullContent = true"
    >
      <template v-if="showFullContent">
        <Viewer :initialValue="report.content"></Viewer>
      </template>
      <template v-else>
        {{ displayedContent }}
        <span class="report-show-content" v-if="exceedLengthLimit"
          >阅读全文
          <span class="iconfont icon-jiantouxia"></span>
        </span>
      </template>
      <div v-if="showFullContent">发布于{{ report.updateTime }}</div>
    </div>
    <div class="report-footer">
      <div class="report-footer-left">
        <!-- 好评与差评 -->
        <span class="report-vote">
          <span
            class="report-like"
            @mouseenter="showSolidLikeIcon = true"
            @mouseleave="showSolidLikeIcon = false"
          >
            100
            <template v-if="showSolidLikeIcon">
              <span class="iconfont icon-dianzan"></span>
            </template>
            <template v-else>
              <span class="iconfont icon-dianzan1"></span>
            </template>
            <template v-if="'current user has like this'"></template>
          </span>
          <span
            class="report-dislike"
            @mouseenter="showSolidDislikeIcon = true"
            @mouseleave="showSolidDislikeIcon = false"
          >
            5

            <template v-if="showSolidDislikeIcon">
              <span class="iconfont icon-badreview-full"></span>
            </template>
            <template v-else>
              <span class="iconfont icon-badreview"></span>
            </template>
          </span>
        </span>
      </div>
      <div class="report-footer-right">
        <span
          class="report-hide-content"
          v-if="showFullContent"
          @click="showFullContent = false"
          >收起
          <span class="iconfont icon-jiantoushang"></span>
        </span>
        <!-- 收起回复 -->
        <span
          type="text"
          class="report-replies"
          @click="showReplies = !showReplies"
          >查看评论
          <span class="iconfont icon-pinglun"></span>
        </span>
      </div>
    </div>
    <template v-if="showReplies">
      <ReplyList :reportId="report.id" />
    </template>
  </div>
</template>

<script>
import { Viewer } from "@toast-ui/vue-editor";

import ReplyList from "./ReplyList";

export default {
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  components: {
    ReplyList,
    Viewer,
  },
  data() {
    return {
      CONTENT_LENGTH_LIMIT: 100,
      showFullContent: false,
      showReplies: false,

      showSolidLikeIcon: false,
      showSolidDislikeIcon: false,
    };
  },
  computed: {
    displayedContent() {
      if (this.report.content) {
        return this.report.content
          .replace(/<.*?>/g, "")
          .slice(0, this.CONTENT_LENGTH_LIMIT);
      } else {
        return null;
      }
    },
    exceedLengthLimit() {
      if (this.report.content) {
        if (this.report.content.length >= this.CONTENT_LENGTH_LIMIT)
          return true;
      }
      return false;
    },
  },
  methods: {
    async like() {},
    async dislike() {},
  },
  mounted() {},
};
</script>

<style>
.report-title {
  cursor: pointer;
  font-size: 22px;
  font-weight: 600;
}
.report-title:hover {
  color: rgb(23, 81, 163);
}
.report-content.hide {
  cursor: pointer;
}
.report-content.hide:hover {
  filter: brightness(40%);
}
.report-show-content {
  color: rgb(23, 81, 153);
}
.tui-editor-contents {
  font-size: 16px;
}

.report-footer {
  display: flex;
  justify-content: space-between;
}
.report-vote span {
  color: rgb(0, 132, 255);
  background-color: rgba(0, 132, 255, 0.1);
  padding: 5px 10px;
  display: inline-block;
  border-radius: 5px;
}
.report-vote span.iconfont {
  background-color: rgba(0, 0, 0, 0);
}
.report-like,
.report-dislike {
  cursor: pointer;
}
.report-dislike {
  margin-left: 10px;
}
.report-replies {
  cursor: pointer;
  margin-left: 10px;
  color: rgb(23, 81, 153);
}
.report-hide-content {
  cursor: pointer;
  color: rgb(23, 81, 153);
}
</style>